export function getBaseUrlForSSR() {
  return "http://neo-publish-nginx";
}

export function getBaseUrlForCSR(): string {
  return process.env.NEXT_PUBLIC_SITE_URL ?? "";
}
